var styles = {"progressIndicator":"VBG__DS__compact-progress-indicator-module__fyOBL","vertical":"VBG__DS__compact-progress-indicator-module__geBSq"};

export { styles as default };
